import { ButtonSize, IconButton } from '@ardoq/button';
import { IconName } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import { t, type I18nLocale } from '@ardoq/i18n';
import type { TourFeedbackSentiment } from './tourTracking';

const ROW_HEIGHT = '28px';

export type TourFeedbackProps = {
  sentiment: TourFeedbackSentiment | null;
  onFeedback: (sentiment: TourFeedbackSentiment) => void;
  i18nLocale: I18nLocale;
};

type FeedbackPromptProps = Pick<TourFeedbackProps, 'onFeedback' | 'i18nLocale'>;

const FeedbackPrompt = ({ onFeedback, i18nLocale }: FeedbackPromptProps) => (
  <FlexBox align="center" gap="small" minHeight={ROW_HEIGHT}>
    <Text variant="caption" color="textModerate">
      {t(i18nLocale, 'productTours:feedback.question', 'Was this helpful?')}
    </Text>
    <FlexBox align="center" gap="xsmall">
      <IconButton
        buttonSize={ButtonSize.SMALL}
        iconName={IconName.THUMB_UP}
        label={t(
          i18nLocale,
          'productTours:feedback.positive',
          'Yes, this tour helped me.'
        )}
        onClick={() => onFeedback('positive')}
      />
      <IconButton
        buttonSize={ButtonSize.SMALL}
        iconName={IconName.THUMB_DOWN}
        label={t(
          i18nLocale,
          'productTours:feedback.negative',
          'No, this tour didn’t help.'
        )}
        onClick={() => onFeedback('negative')}
      />
    </FlexBox>
  </FlexBox>
);

export const TourFeedback = ({
  sentiment,
  onFeedback,
  i18nLocale,
}: TourFeedbackProps) => (
  <>
    <div role="status">
      {sentiment && (
        <FlexBox align="center" minHeight={ROW_HEIGHT}>
          <Text variant="caption" color="textModerate">
            {t(
              i18nLocale,
              'productTours:feedback.thankYou',
              'Thanks for the feedback.'
            )}
          </Text>
        </FlexBox>
      )}
    </div>
    {!sentiment && (
      <FeedbackPrompt onFeedback={onFeedback} i18nLocale={i18nLocale} />
    )}
  </>
);
